<template>
  <div
    class="slideShowContainer"
    @keydown.left="keyboardLeftClick"
    @keydown.right="keyboardRightClick"
  >
    <div class="header pointer">
      <span class="close-btn pointer" @click="this.$props.toggleSlideShow">
        <i class="material-icons">close</i><label class="pl-1">Close</label>
      </span>
      <label style="color: white; width: 33.33%">{{
        currentIndex + 1 + " / " + this.$props.imageArray.length
      }}</label>
      <!-- top like share container -->
      <div class="like-share-container">
        <div class="icon-container pointer" @click="addLike">
          <i
            class="material-icons"
            :style="getImageDescription.isLiked ? 'color:#ff0000' : ''"
            >{{
              getImageDescription.isLiked ? "favorite" : "favorite_outline"
            }}</i
          >
        </div>
        <div
          class="icon-container ml-2 pointer"
          @click="
            share(
              getImageDescription.photoId,
              getImageDescription.caption === ''
                ? 'n'
                : getImageDescription.caption
            )
          "
        >
          <img src="/static/img/ic-reply.svg" class="share-icon" />
        </div>
      </div>
      <!-- /top like share container  -->
    </div>

    <div class="carousel-container">
      <v-carousel
        hide-delimiters
        :height="screenW >= 800 ? 'auto' : 400"
        v-model="currentIndex"
        :cycle="false"
      >
        <v-carousel-item
          v-for="(item, i) in this.$props.imageArray"
          :key="i"
          :lazy="true"
        >
          <div>
            <img
              :src="listviewImage(`${item.photoId}`, item)"
              alt="image"
              class="slide-image"
              width="auto"
            />
          </div>
        </v-carousel-item>
      </v-carousel>
    </div>
    <div class="photo-description">
      <!-- photographer profile det content-->
      <div class="photographer-profile-det-container">
        <div
          style="display: flex"
          :class="
            getImageDescription.uploader !== 'admin'
              ? 'pointer photographer-profile-user'
              : 'photographer-profile'
          "
        >
          <img
            v-if="getImageDescription.uploader !== 'admin'"
            :src="getImageDescription.mediaSourceInformation.photoGrapherPic"
            @click="
              getImageDescription.uploader !== 'admin'
                ? $router.push(
                    `/profile?selected_tab=checkins&profile_id=${getImageDescription.mediaSourceInformation.photoGrapherId}`
                  )
                : ''
            "
            alt="profile-photo"
          />
          <div class="name-container text-xs-left">
            <div>
              <span
                @click="
                  getImageDescription.uploader !== 'admin'
                    ? $router.push(
                        `/profile?selected_tab=checkins&profile_id=${getImageDescription.mediaSourceInformation.photoGrapherId}`
                      )
                    : ''
                "
                >{{
                  getImageDescription.mediaSourceInformation.photoGrapherName
                }}</span
              >
              <span @click="$modal.show('license-modal')">©</span>
            </div>
          </div>
        </div>
      </div>

      <!-- /photographer profile det content-->

      <!-- /photographer profile det -->
      <label class="photo-caption">{{ getImageDescription.caption }}</label>
    </div>
  </div>
</template>
<script>
import imageLinks from "../../mixin/imageLinks";
import share_m from "../../mixin/share";
export default {
  name: "slideShow",
  props: {
    toggleSlideShow: Function,
    imageArray: Array,
    like: Function,
  },
  data() {
    return {
      items: null,
      screenW: 0,
      currentIndex: 0,
    };
  },
  mixins: [imageLinks, share_m],
  computed: {
    getImageDescription() {
      let currentImageDetails = this.$props.imageArray[this.currentIndex];
      return currentImageDetails;
    },
  },
  methods: {
    getBackgroundImage(image) {
      return `background-image: url(${image})`;
    },
    addLike() {
      this.$emit("like", this.getImageDescription, false);
    },
  },
  mounted() {
    this.items = this.$props.imageArray;
    window.addEventListener("keydown", function (event) {
      switch (event.key) {
        case "ArrowLeft":
          document
            .getElementsByClassName("v-carousel__prev")[0]
            .firstChild.click();
          break;
        case "ArrowRight":
          document
            .getElementsByClassName("v-carousel__next")[0]
            .firstChild.click();
          break;
      }
    });
  },
  beforeDestroy() {
    window.addEventListener("keydown", function (event) {
      switch (event.key) {
        case "ArrowLeft":
          this.keyboardLeftClick;
          break;
        case "ArrowRight":
          this.keyboardRightClick;
          break;
      }
    });
  },
  created() {
    this.screenW = screen.width;
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/colors.scss";
.close-btn {
  width: 33.33%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.slideShowContainer {
  background: rgba($color: #000000, $alpha: 1);
  position: fixed;
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  z-index: 1800;
}

.header {
  color: white;
  padding: 10px 30px 10px 30px;
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  justify-content: space-between;
}

.slider-item-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.slider-item {
  overflow: hidden;
}
.v-responsive__content {
  display: flex;
  justify-content: center;
  align-items: center;
}

.slide-image {
  max-width: 1280px;
  max-height: 600px;
}

@media screen and (max-width: 1280px) {
  .slide-image {
    max-width: 100%;
    max-height: 600px;
  }
}

@media screen and (min-width: 1720px) {
  .slide-image {
    max-width: 1600px;
    max-height: 700px;
  }
}

@media screen and (max-width: 768px) {
  .slide-image {
    max-width: 100%;
    max-height: 400px;
  }
}

.carousel-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
}

.photo-description {
  font-family: Montserrat;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.2;
  color: #b9b9b9;
  margin-bottom: 40px;
  .photo-caption {
    display: block;
  }
  @media screen and (max-width: 768px) {
    .photo-caption {
      display: none;
    }
  }
}

.photographer-profile-det-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  flex-wrap: nowrap;
  font-size: 14px;
  @media only screen and (max-width: 768px) {
    height: auto;
    flex-wrap: wrap;
  }
  img {
    height: 1.5em;
    width: 1.5em;
    object-fit: cover;
    border-radius: 100%;
  }
  .no-profile-image {
    width: 1.5em;
    height: 1.5em;
    border-radius: 100%;
    background: $font-color-3;
    font-size: 20px;
    color: black;
    text-align: center;
    line-height: 1.5em;
    font-weight: bold;
  }

  //
  .name-container {
    margin: auto 0.8em auto 0px;
    font-size: 0.9em;
    text-transform: capitalize;
    font-family: "Montserrat-Regular", -apple-system, BlinkMacSystemFont,
      "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans",
      "Helvetica Neue", sans-serif;
    @media only screen and (max-width: 768px) {
      font-size: 0.6875em;
    }
    font-weight: 500;
  }

  //
  .photographer-profile-user {
    width: calc(100vw / 3);
    color: $font-color-3;
    img {
      margin-right: 0.8em;
    }
    @media only screen and (max-width: 768px) {
      flex-grow: 1;
    }
  }
  //
  .photographer-profile {
    color: $font-color-5;
    @media only screen and (max-width: 768px) {
      flex-grow: 1;
      justify-content: center;
    }
  }
  //
}
.like-share-container {
  display: flex;
  justify-content: flex-end;
  width: 33.33%;
  .icon-container {
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      font-size: 30px;
    }
    .share-icon {
      height: 30px;
      width: 30px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// slideshow.vue?72208fc1